export default "<button data-value=\"{{ value }}\">{{ label }}</button>";